/**
 * Add Fonts here from fontsource
 * https://fontsource.org/docs/getting-started
 */
import "@fontsource-variable/rokkitt";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/400-italic.css";
import "@fontsource/lato/700-italic.css";

/**
 * Add other imports and browser scripts below this line
 */
import React from "react";
import RootElement from "./src/components/rootElement";

export const wrapRootElement = ({ element }) => {
	return <RootElement>{element}</RootElement>;
};
